import * as Yup from 'yup';

const apiKeySchema = Yup.object().shape({
    name: Yup.string().required('Vul een naam in'),
});

export default apiKeySchema;
